// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sp-0";
export var checkoutRateBadgeLink = "_sp-1";